import '@/hooks';
import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import vuetify from '@/plugins/vuetify';
import Vuelidate from 'vuelidate';

import { fiLockDown, appModeCheck, GlobalWorkspacePlugin } from '@kasasa/fbase-components/lib';
Vue.use(Vuelidate);

Vue.config.productionTip = false;

// use following if you want /:clientId lockdown
router.beforeEach(fiLockDown(store));

// use following if you do NOT want /:clientId lockdown
// store.dispatch('auth/initializePortalSession', store);

import SiteStore from '@/store/modules/SiteStore';
store.registerModule('sites', SiteStore);



// assumes fbase-portalapp proxy of /api/session/portalapp-status
router.beforeEach(appModeCheck(store));

Vue.use(GlobalWorkspacePlugin, {store});

new Vue({
	router,
	store,
	vuetify,
	render: h => h(App)
}).$mount('#app');
